export const EXISTING_EMPLOYEE_ID_QUERY_PARAM = 'existingEmployeeId';
export const HRIS_ONBOARDING_REQUEST_ID_QUERY_PARAM = 'hrisOnboardingRequestId';
export const HRIS_OFFBOARDING_REQUEST_ID_QUERY_PARAM =
  'hrisOffboardingRequestId';
